




















import Vue from 'vue';

export default Vue.extend({
  props: {
    value: { type: undefined, default: undefined },
    to: { type: String, default: undefined },
    color: { type: String, default: 'interaction-lighten-1' },
    activeColor: { type: String, default: 'interaction' },
    visitedColor: { type: String, default: 'interaction-lighten-2' },
    pathSeperator: { type: String, default: '\u203A' },
    disabled: { type: Boolean, default: false },
  },
  data: () => ({
    isActive: false,
    isVisited: false,
  }),
  computed: {
    classList(): {} {
      return {
        'p-breadcrumb-path-link': true,
        visited: this.isVisited && !this.disabled,
        active: this.isActive && !this.disabled,
        disabled: this.disabled,
        [`text-color-${this.color}`]: !this.isActive && !this.isVisited && !this.disabled,
        [`text-color-${this.activeColor}`]: this.isActive && !this.disabled,
        [`text-color-${this.visitedColor}`]: this.isVisited && !this.disabled,
      };
    },
  },
  methods: {
    onBreadcrumbClick(toggle: ()=>void) {
      if (!this.disabled) {
        toggle();
      }
    },
    onActiveChange(isActive: boolean) {
      this.isActive = isActive;
    },
  },
});
